import React from 'react';
import './botDiv.css'
import { Link } from 'react-router-dom';
import animImg from '../../assets/bib.gif';
import SouthWestIcon from '@mui/icons-material/SouthWest';
import Version from '../version/Version';
import Socials from '../socials/Socials';


function BotDiv() {
  return (
    <div className='botDiv'>
        <div className="botDiv-container">
            <div className="bot-div-top">
                <div className="bot-div-img">
                    <img src={animImg} alt="" />
                </div>
                <h3>Want to connect?</h3>
            </div>
            <hr/>
            <div className="bot-btn-arrow">
                  <SouthWestIcon sx={{ fontSize: `calc(clamp(3.5em, 5vw, 8em) * .5)` }}/>
            </div>
            <div className="bot-contact-btn">
                <Link to='/contact'>
                    <div className="bot-contact-btn-hover"></div>
                    <p> Send a message...</p>
                </Link>
            </div>
            <div className="bot-div-bot">
                <div className="bot-div-btns">
                    <Link to="mailto:bsahoo779@gmail.com">
                        <div className="bot-div-btn">
                            <div className="bot-div-btn-hover"></div>
                            <h4 className='bot-btn-titl'>bsahoo779@gmail.com</h4>
                        </div>
                    </Link>
                </div>
            </div>
        </div>
        <div className="bot-footer">
            <Version/>
            <hr />
            <Socials/>
        </div>
    </div>
  )
}

export default BotDiv